module.exports = __webpack_public_path__ + "img/logo_UEEx.045a2563.png";